import React, { useEffect, useState } from "react";
import DropDownButton from "../../Components/DropDownButton";
import { FetchLifestyleDeterminants } from "../../../api/helper";
import LifeStyleHistory from "./PatientHistoryComponents/LifeStyleHistory";
import PatientFamilyHistory from "./PatientHistoryComponents/PatientFamilyHistory";
import PatientMedicalHistory from "./PatientHistoryComponents/PatientMedicalHistory";
import MentalHealthHistory from "./PatientHistoryComponents/MentalHealthHistory";
import SurgicalHistory from "./PatientHistoryComponents/SurgicalHistory";

const DetailsOverviewPatient = () => {
  const [isintakeFormVisible, setIsintKEFormVisible] = useState(false);

  const toggleintakeFormVisibility = () => {
    setIsintKEFormVisible(!isintakeFormVisible);
  };



  return (
    <div className="patient_right">
      <div className="paitent_Head_buttons_div">
        <div>
          <div className="patient_education_button">
            <div className="notes_img_background">
              <img
                src={require("../../assest/Images/notes_Icon.png")}
                alt="Notes Icon"
              />
            </div>
            <div className="last_signed_txt">Last Signed Note</div>
            <img
              src={require("../../assest/Images/twosidearrow.png")}
              alt="Arrow"
            />
          </div>
          <div className="patient_education_button">
            <div className="notes_img_background">
              <img
                src={require("../../assest/Images/book_icon.png")}
                alt="Book Icon"
              />
            </div>
            <div className="last_signed_txt">Education</div>
            <img
              src={require("../../assest/Images/twosidearrow.png")}
              alt="Arrow"
            />
          </div>
        </div>
        <div style={{ marginLeft: 30 }} onClick={toggleintakeFormVisibility}>
          <div className="patient_education_button">
            <div className="notes_img_background">
              <img
                src={require("../../assest/Images/notes_Icon.png")}
                alt="Notes Icon"
              />
            </div>
            <div className="last_signed_txt">Intake Forms</div>
            <img
              src={require("../../assest/Images/twosidearrow.png")}
              alt="Arrow"
            />
          </div>
          <div className="patient_education_button">
            <div className="notes_img_background">
              <img
                src={require("../../assest/Images/book_icon.png")}
                alt="Notes Icon"
              />
            </div>
            <div className="last_signed_txt">Create New Appointment</div>
          </div>
        </div>
      </div>

      <div className="Lifestyle_Determinants_main_div1">
        <LifeStyleHistory />
       <PatientFamilyHistory/>

      <PatientMedicalHistory/>
      </div>

      <div className="Lifestyle_Determinants_main_div_two1">
     <MentalHealthHistory/>
     <SurgicalHistory/>
       
      </div>
      {isintakeFormVisible && (
        <div className="INTAKE_Chart_popup">
          <div className="custom-table-container">
            <table className="custom-table">
              <thead>
                <tr className="custom-table-header">
                  <th className="custom-select-column">Select</th>
                  <th className="custom-form-name-column">Form Name</th>
                  <th className="custom-status-column">Status</th>
                  <th className="custom-sent-column">Sent</th>
                  <th className="custom-completed-column">Completed</th>
                  <th className="custom-actions-column">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr className="custom-table-row">
                  <td>
                    <input type="checkbox" className="custom-checkbox" />
                  </td>
                  <td className="custom-form-name">PHQ9</td>
                  <td className="custom-form-name">Sent</td>
                  <td className="custom-form-name">8/2</td>
                  <td className="custom-form-name">-</td>
                  <td>
                    <button className="custom-edit-button">Edit</button>
                  </td>
                </tr>
                <tr className="custom-table-row">
                  <td>
                    <input type="checkbox" className="custom-checkbox" />
                  </td>
                  <td className="custom-form-name">PHQ9</td>
                  <td className="custom-form-name">Sent</td>
                  <td className="custom-form-name">8/2</td>
                  <td className="custom-form-name">-</td>
                  <td>
                    <button className="custom-edit-button">Edit</button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default DetailsOverviewPatient;
